import React from 'react';
import './TextField.css';

function TextField({fieldConfig, value, showValidationError, inputRef, onFieldUpdate, lang}) {
    return (
            <label className={`TextField-label${showValidationError ? ' TextField-label--error' : ''}`}>
                <span className="TextField-title">{fieldConfig.label}</span>
                <div className="TextField-field-box">
                    <input
                            value={value}
                            ref={inputRef}
                            type={fieldConfig.type}
                            name={fieldConfig.id}
                            placeholder={fieldConfig.placeholder}
                            className="TextField-input"
                            maxLength="100"
                            autoComplete="off"
                            lang={lang}
                            onChange={(event) => {
                                onFieldUpdate(fieldConfig.id, event.target.value, fieldConfig);
                            }}
                    />
                </div>
                <span className="TextField-error-msg">{fieldConfig.errorMsg}</span>
            </label>
    );
}

export default TextField;



// WEBPACK FOOTER //
// ./src/components/Form/TextField.js